// extracted by mini-css-extract-plugin
export default {"CompanionAppSection":"CompanionAppSection_CompanionAppSection__GikBO","Text":"CompanionAppSection_Text__8bEjt","Themed":"CompanionAppSection_Themed__2xi2M"};